<template>
  <div class="">
    <component
      v-for="toast in toasts"
      :key="toast.id"
      :is="toast.component"
      v-bind="toast.props"
      @close="removeToast(toast.id)"
    />
  </div>
</template>

<script setup>
import { useStore } from 'vuex';
import { computed } from 'vue';

const store = useStore();
const toasts = computed(() => store.state.toast.toasts);
const removeToast = (id) => store.dispatch('toast/removeToast', id);
</script>
